import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import {ApiServiceService} from '../api-service.service';
import {StorageService} from '../service/storage.service';
import {InvestormenuComponent} from './investormenu.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [RouterModule, MatDialogModule, CommonModule],
    declarations: [InvestormenuComponent],
    providers: [ApiServiceService, StorageService],
    exports: [InvestormenuComponent]
})
export class InvestormenuModule {
}
